import {
	SEARCH_UPDATE_DOCUMENT_PRIORITY,
	SEARCH_CLEAR_CONCEPT_TARGET_TERMS,
	SEARCH_ADD_CONCEPT_TARGET_TERMS,
	SEARCH_UPDATE_DOCUMENT_DATE,
	SEARCH_SET_SOURCE_FILTER,
	SEARCH_LOAD_STORAGE,
	REQUEST_SEARCH_TYPING,
	SEARCH_RESULTS_CLEAR,
	SELECTED_SEARCH,
	UPDATE_SEARCH_METADATA,
	GET_FILE_LIST_REQUEST,
	GET_FILE_LIST_REQUEST_SUCCESS,
	GET_FILE_LIST_REQUEST_FAILED,
	GET_FILE_LIST_REQUEST_FAILED_CLEAR,
} from "../types"

export const setSearchLoad = (searchReducer) => ({
	type: SEARCH_LOAD_STORAGE,
	payload: searchReducer,
})

export const setCurrentSourceFilter = (filter) => ({
	type: SEARCH_SET_SOURCE_FILTER,
	payload: filter,
})

//Search Success
export const clearRequestSearch = () => ({
	type: SEARCH_RESULTS_CLEAR,
})

export const updateDocumentSearchPriority = (document_id, priority) => ({
	type: SEARCH_UPDATE_DOCUMENT_PRIORITY,
	payload: { id: document_id, priority: priority },
})

export const updateDocumentSearchDate = (document_id, newdate) => ({
	type: SEARCH_UPDATE_DOCUMENT_DATE,
	payload: { id: document_id, date: newdate },
})

export const callClearSearchConceptTargetTerms = (value) => ({
	type: SEARCH_CLEAR_CONCEPT_TARGET_TERMS,
	payload: value,
})

export const callUpdateSearchConceptTargetTerms = (terms) => ({
	type: SEARCH_ADD_CONCEPT_TARGET_TERMS,
	payload: terms,
})

export const newSearchSearch = (searchObject, filter = [""], categories = [""], cancelToken = null, location, currentTag = "") => ({
	type: REQUEST_SEARCH_TYPING,
	payload: {
		searchObject: searchObject,
		filter: filter,
		categories: categories,
		cancelToken: cancelToken,
		location: location,
		selectedTag: currentTag,
	},
})

export const setSelectedSearch = (data) => ({
	type: SELECTED_SEARCH,
	payload: data,
})

//update search metadata
export const updateSearchMetadata = (data) => ({
	type: UPDATE_SEARCH_METADATA,
	payload: data,
})

export const getFileListRequest = (data) => ({
	type: GET_FILE_LIST_REQUEST,
	payload: data,
})

export const getFileListRequestSuccess = (data) => ({
	type: GET_FILE_LIST_REQUEST_SUCCESS,
	payload: data,
})

export const getFileListRequestFailed = (data) => ({
	type: GET_FILE_LIST_REQUEST_FAILED,
	payload: data,
})

export const getFileListRequestFailedClear = (data) => ({
	type: GET_FILE_LIST_REQUEST_FAILED_CLEAR,
})
